import { useTranslation } from 'react-i18next'

import { VideoCard } from '@/components/molecules/video-card'
import { ALL_VIDEOS, INTRO_VIDEO } from '@/config/videos'
import { useFirstTimeSeen } from '@/hooks/useFirstTimeSeen'

export const VideoLibrary = () => {
  const { isFirstTime, markAsSeen } = useFirstTimeSeen('individual-intro-video')
  const { t } = useTranslation()

  const gridVideos = isFirstTime ? ALL_VIDEOS.slice(1) : ALL_VIDEOS

  return (
    <section className="space-y-4">
      <h4 className="text-lg font-heading font-bold">{t('homePage.videoLibrary.title')}</h4>

      {/* Auto-fill so cards reflow by the actual available width (viewport-independent) — stays
          readable when the chat/preview panels shrink this column. */}
      <div className="grid grid-cols-[repeat(auto-fill,minmax(150px,1fr))] gap-4">
        {isFirstTime && (
          <div className="max-w-sm">
            <VideoCard
              defaultOpen
              featured
              onOpenChange={open => {
                if (!open) markAsSeen()
              }}
              titleKey={INTRO_VIDEO.titleKey}
              youtubeId={INTRO_VIDEO.youtubeId}
            />
          </div>
        )}
        {gridVideos.map(video => (
          <VideoCard key={video.id} titleKey={video.titleKey} youtubeId={video.youtubeId} />
        ))}
      </div>
    </section>
  )
}

export default VideoLibrary
